import { render, staticRenderFns } from "./QuickDeclareStepSummary.vue?vue&type=template&id=150b240a&scoped=true&"
import script from "./QuickDeclareStepSummary.vue?vue&type=script&lang=js&"
export * from "./QuickDeclareStepSummary.vue?vue&type=script&lang=js&"
import style0 from "./QuickDeclareStepSummary.vue?vue&type=style&index=0&id=150b240a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b240a",
  null
  
)

export default component.exports